import PropTypes from 'prop-types';
import React from 'react';
import {formatMonthDate} from 'src/shared/utils/date';
import {button} from 'src/styles/modules/button.module.scss';
import DeflectionBilling from 'src/svgs/scheduleCallback/DeflectionBilling.svg';
import DeflectionCall from 'src/svgs/scheduleCallback/DeflectionCall.svg';
import {header} from '../header.module.scss';
import {
  icons,
  interstitialHeader,
  interstitialButton,
  interstitialCard,
  suggestionText,
} from '../interstitial.module.scss';

export const BillingInterstitial = ({
  amountDue,
  billPayUrl,
  delinquent,
  eligibleForPromiseToPay,
  inSoftDisconnect,
  onBillPay,
  onGetCall,
  payByDate,
}) => (
  <>
    <header className={header}>
      <h1>Looks like payment is {((delinquent && !inSoftDisconnect) || eligibleForPromiseToPay) ? 'overdue' : 'required'}</h1>
      <p>You can manage your bill below or get a call to speak with an agent.</p>
    </header>
    <div className={interstitialCard}>
      <div className={interstitialHeader}>
        <DeflectionBilling className={icons} />
        <p>Manage Billing</p>
        <a className={`${button} ${interstitialButton}`} href={billPayUrl} onClick={onBillPay}>Make a Payment</a>
      </div>
      <hr />
      <div className={suggestionText}>
        {
          (delinquent && !inSoftDisconnect)
          && <p>Your payment is late. Please pay at least ${amountDue} to avoid service interruptions.</p>
        }
        {
          eligibleForPromiseToPay
          && <p>Schedule payments totaling at least ${amountDue} by {formatMonthDate(payByDate)} to avoid a service interruption.</p>
        }
        {
          inSoftDisconnect
          && <p>Schedule payments totaling at least ${amountDue} by {formatMonthDate(payByDate)} to restore service.</p>
        }
      </div>
    </div>

    <div className={interstitialCard}>
      <div className={interstitialHeader}>
        <DeflectionCall className={icons} />
        <p>I&apos;d like to speak with an agent</p>
        <button className={`${button} ${interstitialButton}`} onClick={onGetCall}>Get a Call</button>
      </div>
    </div>
  </>
);

BillingInterstitial.propTypes = {
  amountDue: PropTypes.number.isRequired,
  billPayUrl: PropTypes.string.isRequired,
  delinquent: PropTypes.bool.isRequired,
  eligibleForPromiseToPay: PropTypes.bool.isRequired,
  inSoftDisconnect: PropTypes.bool.isRequired,
  onBillPay: PropTypes.func.isRequired,
  onGetCall: PropTypes.func.isRequired,
  payByDate: PropTypes.string.isRequired,
};
